import { ClosedHours } from './ClosedHours';
export default ClosedHours;